import { HEADER_DETAILS } from 'src/data/ProcessingRequests/constant';

export default function Header() {
  return (
    <header className="font-bold">
      <div className="pl-10 pr-4">
        {HEADER_DETAILS.titleCode}-{HEADER_DETAILS.chapterCode}-{HEADER_DETAILS.sectionCode}.{' '}
        {HEADER_DETAILS.section}
      </div>
    </header>
  );
}
